export enum RouteName {
    Main = "/",
    Media = "/media",
    Map = "/map",
    Login = "/login",
    Units = "/freeunits",
    Trucks = "/freetrucks",
    RegisterUser = "/register/user",
    RegisterUserId = "/register/user/:identifier",
    RegisterCompany = "/register/company",
    ChangePassword = "/user/changePassword",
    ChangePasswordSuccess = "/user/changePasswordSuccess",
    PasswordResetedSuccess = '/passwordResetedSuccess',
    ResetPassword = "/resetpassword",
    Settings = "/settings",
    Statistics = "/statistics",
    AdminCompanies = "/admin/companies",
    AdminFeedback = "/admin/feedback",
    Help = "/help",
    Terms = "/terms",
    Privacy = "/privacy",
    Unit = "/unit/:identifier",
    Truck = "/truck/:identifier"
}


// WEBPACK FOOTER //
// ./src/routeNames.ts